import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteZoneDocument } from './delete.generated';

export const useDeleteZone = (options: ApiOptions<typeof DeleteZoneDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteZoneDocument, {
    ...useNotifications(DeleteZoneDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.zones.delete_success'),
    }),

    ...options,
  });
};
